import { Bar, Line, Pie, Doughnut, Radar, HorizontalBar, PolarArea, Bubble, Scatter } from 'vue-chartjs'
import ValueChecker from "@/services/ValueChecker";

const chartMap = {
    bar: Bar,
    line: Line,
    pie: Pie,
    doughnut: Doughnut,
    radar: Radar,
    horizontalbar: HorizontalBar,
    polararea: PolarArea,
    bubble: Bubble,
    scatter: Scatter
}

export function createChart(type) {
    const ChartComponent = chartMap[type.toLowerCase()]
    if (!ChartComponent) {
        throw new Error(`Unknown chart type: ${type}`)
    }

    return {
        extends: ChartComponent,
        props: {
            chartData: {
                type: Object,
                required: true
            },
            componentIndex: {},
            showLegend: {
                default: () => { return false; },
            },
            showGrid: {
                default: () => { return false; },
            },
            dashedLines: {
                default: () => { return false; },
            },
            options: {
                type: Object,
            }
        },
        mounted() {
            this.renderChart(this.chartData, this.options);
        },
        methods: {
            setDashedLines(dashedLines) {
                if (dashedLines) {
                    this._chart.options.elements.line.borderDash = [5, 5];
                } else {
                    this._chart.options.elements.line.borderDash = [];
                }

                this._chart.update();
            },
            setLegend(showLegend) {
                this._chart.options.legend.display = showLegend;
                this._chart.update();
            },
        },
        watch: {
            chartData: {
                handler(newVal) {
                    this.renderChart(newVal, this.options)
                },
                deep: true
            },
            dashedLines: {
                handler: function(newData, oldData) {
                    this.setDashedLines(newData);
                }
            },
            showLegend: {
                handler: function (newData, oldData) {
                    this.setLegend(newData);
                }
            },
            showGrid: {
                handler: function (newData, oldData) {
                    if (ValueChecker.isArray(this._chart.options.scales.xAxes)) {
                        this._chart.options.scales.xAxes[0].gridLines.display = newData;
                    }

                    if (ValueChecker.isArray(this._chart.options.scales.yAxes)) {
                        this._chart.options.scales.yAxes[0].gridLines.display = newData;
                    }

                    this._chart.update();
                }
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/chart/ChartFactory.js